// routes
import { paths } from 'src/routes/paths';
// utils
import axios from 'src/utils/axios';

// ----------------------------------------------------------------------

function jwtDecode(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  return JSON.parse(jsonPayload);
}

// ----------------------------------------------------------------------

export const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  const decoded = jwtDecode(accessToken);

  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

// ----------------------------------------------------------------------

export const tokenExpired = (exp) => {
  // eslint-disable-next-line prefer-const
  let expiredTimer;

  const currentTime = Date.now();

  // Test token expires after 10s
  // const timeLeft = currentTime + 10000 - currentTime; // ~10s
  const timeLeft = exp * 1000 - currentTime;

  clearTimeout(expiredTimer);

  expiredTimer = setTimeout(() => {
    // sessionStorage.removeItem(TOKEN);
    // sessionStorage.removeItem(USER_SESSION);
  }, timeLeft);
};

// ----------------------------------------------------------------------
export const TOKEN = 'ADMIN_ID_JWT';
export const REFRESH_TOKEN = 'ADMIN_REFRESH_JWT';
const USER_SESSION = 'ADMIN_ID_SES';
const USER_ROLE_ID = 'ADMIN_ID_ROLE';
export const getJwt = () => sessionStorage.getItem(TOKEN);
export const getUserId = () => sessionStorage.getItem(USER_SESSION);
export const setSession = (accessToken) => {
  if (accessToken) {
    sessionStorage.setItem(TOKEN, accessToken);

    // axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    axios.defaults.headers.common.Authorization = `${accessToken}`;

    const { exp } = jwtDecode(accessToken); // ~3 days by minimals server
    tokenExpired(exp);
  } else {
    sessionStorage.removeItem(TOKEN);

    delete axios.defaults.headers.common.Authorization;
  }
};
export const setRefresh = (refreshToken) => {
  sessionStorage.setItem(REFRESH_TOKEN, refreshToken);
};
export const getRefresh = () => sessionStorage.getItem(REFRESH_TOKEN);

export const setUserId = (userId) => {
  sessionStorage.setItem(USER_SESSION, userId);
};
export const removeAllSession = () => {
  sessionStorage.removeItem(USER_SESSION);
  sessionStorage.removeItem(TOKEN);
};
